export enum WaterfallTenderRateQuoteFailedReason {
  UNSUPPORTED_TENDER_METHOD = 'UNSUPPORTED_TENDER_METHOD',
  DO_NOT_DISPATCH = 'DO_NOT_DISPATCH',
  INVALID_TENDER_REQUEST = 'INVALID_TENDER_REQUEST',
}
